import { ChainData } from "./types";

export const supportedChainsProduction: ChainData[] = [
  // {
  //   name: "Ethereum Mainnet",
  //   short_name: "eth",
  //   chain: "ETH",
  //   network: "mainnet",
  //   chain_id: 1,
  //   network_id: 1,
  //   rpc_url: "https://mainnet.infura.io/v3/%API_KEY%",
  //   native_currency: {
  //     symbol: "ETH",
  //     name: "Ethereum",
  //     decimals: 18,
  //
  //
  //   },
  // },
  {
    name: "Binance Smart Chain",
    short_name: "bsc",
    chain: "smartchain",
    network: "mainnet",
    chain_id: 56,
    network_id: 56,
    rpc_url: "https://bsc-dataseed.binance.org/",
    native_currency: {
      symbol: "BNB",
      name: "BNB",
      decimals: 18,
    },
    block_explorer_urls: ["https://bscscan.com/"],
  },
  {
    name: "OKXChain Mainnet",
    short_name: "okt",
    chain: "okxchain",
    network: "mainnet",
    chain_id: 66,
    network_id: 66,
    rpc_url: "https://exchainrpc.okex.org",
    native_currency: {
      name: "OKXChain Global Utility Token",
      symbol: "OKT",
      decimals: 18,
    },
    block_explorer_urls: ["https://www.oklink.com/okc/"],
  },
  {
    name: "CoinEx Smart Chain Mainnet",
    short_name: "cet",
    chain: "CSC",
    network: "mainnet",
    chain_id: 52,
    network_id: 52,
    rpc_url: "https://rpc.coinex.net",
    native_currency: {
      name: "CoinEx Chain Native Token",
      symbol: "cet",
      decimals: 18,
    },
    block_explorer_urls: ["https://www.coinex.net/"],
  },
  {
    name: "Polygon Mainnet",
    short_name: "MATIC",
    chain: "Polygon",
    network: "mainnet",
    chain_id: 137,
    network_id: 137,
    rpc_url: "https://polygon-rpc.com/",
    native_currency: {
      name: "MATIC",
      symbol: "MATIC",
      decimals: 18,
    },
    block_explorer_urls: ["https://polygonscan.com/"],
  },
];

const supportedChains: ChainData[] = [
  // {
  //   name: "Ethereum Ropsten",
  //   short_name: "rop",
  //   chain: "ETH",
  //   network: "ropsten",
  //   chain_id: 3,
  //   network_id: 3,
  //   rpc_url: "https://ropsten.infura.io/v3/%API_KEY%",
  //   native_currency: {
  //     symbol: "ETH",
  //     name: "Ethereum",
  //     decimals: 18,
  //
  //
  //   },
  // },
  // {
  //   name: "Ethereum Rinkeby",
  //   short_name: "rin",
  //   chain: "ETH",
  //   network: "rinkeby",
  //   chain_id: 4,
  //   network_id: 4,
  //   rpc_url: "https://rinkeby.infura.io/v3/%API_KEY%",
  //   native_currency: {
  //     symbol: "ETH",
  //     name: "Ethereum",
  //     decimals: 18,
  //
  //
  //   },
  // },
  // {
  //   name: "Ethereum Görli",
  //   short_name: "gor",
  //   chain: "ETH",
  //   network: "goerli",
  //   chain_id: 5,
  //   network_id: 5,
  //   rpc_url: "https://goerli.infura.io/v3/%API_KEY%",
  //   native_currency: {
  //     symbol: "ETH",
  //     name: "Ethereum",
  //     decimals: 18,
  //
  //
  //   },
  // },
  // {
  //   name: "RSK Mainnet",
  //   short_name: "rsk",
  //   chain: "RSK",
  //   network: "mainnet",
  //   chain_id: 30,
  //   network_id: 30,
  //   rpc_url: "https://public-node.rsk.co",
  //   native_currency: {
  //     symbol: "RSK",
  //     name: "RSK",
  //     decimals: 18,
  //
  //
  //   },
  // },
  // {
  //   name: "Ethereum Kovan",
  //   short_name: "kov",
  //   chain: "ETH",
  //   network: "kovan",
  //   chain_id: 42,
  //   network_id: 42,
  //   rpc_url: "https://kovan.infura.io/v3/%API_KEY%",
  //   native_currency: {
  //     symbol: "ETH",
  //     name: "Ethereum",
  //     decimals: 18,
  //
  //
  //   },
  // },
  // {
  //   name: "Ethereum Classic Mainnet",
  //   short_name: "etc",
  //   chain: "ETC",
  //   network: "mainnet",
  //   chain_id: 61,
  //   network_id: 1,
  //   rpc_url: "https://ethereumclassic.network",
  //   native_currency: {
  //     symbol: "ETH",
  //     name: "Ethereum",
  //     decimals: 18,
  //
  //
  //   },
  // },
  // {
  //   name: "POA Network Sokol",
  //   short_name: "poa",
  //   chain: "POA",
  //   network: "sokol",
  //   chain_id: 77,
  //   network_id: 77,
  //   rpc_url: "https://sokol.poa.network",
  //   native_currency: {
  //     symbol: "POA",
  //     name: "POA",
  //     decimals: 18,
  //
  //
  //   },
  // },
  // {
  //   name: "POA Network Core",
  //   short_name: "skl",
  //   chain: "POA",
  //   network: "core",
  //   chain_id: 99,
  //   network_id: 99,
  //   rpc_url: "https://core.poa.network",
  //   native_currency: {
  //     symbol: "POA",
  //     name: "POA",
  //     decimals: 18,
  //
  //
  //   },
  // },
  // {
  //   name: "xDAI Chain",
  //   short_name: "xdai",
  //   chain: "POA",
  //   network: "dai",
  //   chain_id: 100,
  //   network_id: 100,
  //   rpc_url: "https://dai.poa.network",
  //   native_currency: {
  //     symbol: "xDAI",
  //     name: "xDAI",
  //     decimals: 18,
  //
  //
  //   },
  // },
  // {
  //   name: "Callisto Mainnet",
  //   short_name: "clo",
  //   chain: "callisto",
  //   network: "mainnet",
  //   chain_id: 820,
  //   network_id: 1,
  //   rpc_url: "https://clo-geth.0xinfra.com/",
  //   native_currency: {
  //     symbol: "CLO",
  //     name: "CLO",
  //     decimals: 18,
  //
  //
  //   },
  // },
  {
    name: "Hardhat",
    short_name: "hdh",
    chain: "ETH",
    network: "hardhat",
    chain_id: 31337,
    network_id: 31337,
    rpc_url: "http://localhost:8545/",
    native_currency: {
      symbol: "ETH",
      name: "ETH",
      decimals: 18,
    },
  },
  {
    name: "BSC Testnet",
    short_name: "bsc",
    chain: "smartchain",
    network: "testnet",
    chain_id: 97,
    network_id: 97,
    rpc_url: "https://data-seed-prebsc-1-s1.binance.org:8545",
    native_currency: {
      symbol: "BNB",
      name: "BNB",
      decimals: 18,
    },
    block_explorer_urls: ["https://testnet.bscscan.com/"],
  },
  {
    name: "OKXChain Testnet",
    short_name: "tokt",
    chain: "okxchain",
    network: "testnet",
    chain_id: 65,
    network_id: 65,
    rpc_url: "https://exchaintestrpc.okex.org",
    native_currency: {
      name: "OKExChain Global Utility Token in testnet",
      symbol: "OKT",
      decimals: 18,
    },
    block_explorer_urls: ["https://www.oklink.com/okc-test/"],
  },
  {
    name: "CoinEx Smart Chain Testnet",
    short_name: "tcet",
    chain: "CSC",
    network: "testnet",
    chain_id: 53,
    network_id: 53,
    rpc_url: "https://testnet-rpc.coinex.net/",
    native_currency: {
      name: "CoinEx Chain Test Native Token",
      symbol: "cet",
      decimals: 18,
    },
    block_explorer_urls: ["https://testnet.coinex.net/"],
  },
  {
    name: "Polygon Testnet",
    short_name: "maticmum",
    chain: "Polygon",
    network: "testnet",
    chain_id: 80001,
    network_id: 80001,
    rpc_url: "https://rpc-mumbai.maticvigil.com",
    native_currency: {
      name: "MATIC",
      symbol: "MATIC",
      decimals: 18,
    },
    block_explorer_urls: ["https://mumbai.polygonscan.com/"],
  },
];

const getSupportedChains = () =>
  process.env.REACT_APP_ENVIRONMENT === "production"
    ? supportedChainsProduction
    : [...supportedChainsProduction, ...supportedChains];

export default getSupportedChains;
